module.exports = __webpack_public_path__ + "img/forms.a667dea1.svg";